module.exports = {
    digitalPayOrderPlacementErrorCodes: {
        declined: 'Declined',
        deliveryWindow: 'DeliveryWindow',
        invalidPassword: 'InvalidPassword',
        timeout: 'Timeout',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/digitalpay-orderplacement-errorcodes.js